import { render, staticRenderFns } from "./DeliveryDetailDialog.vue?vue&type=template&id=a7006390"
import script from "./DeliveryDetailDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports